module.exports = __webpack_public_path__ + "img/home-2.f471fb37.png";